import UserManualPage from "../../pages/documentation/UserManualPage";

const route = {
  key: "userManual",
  path: "/user-manual",
  component: UserManualPage,
  private: true,
  layout: "main",
  icon: "faBookOpen",
  group: "documentation",
  order: 10,
};

export default route;
